/**
 * Selloa · tintas sugeridas (Versacraft > Speedball > Trodat)
 *
 * Pinta el bloque que prepara snippets/tinta-sugerida.liquid, en la ficha o en el carrito.
 * Cada tinta lleva su foto, una casilla, el color, las unidades, el precio y «Ver tinta».
 * «Ver colores» (26/10, en lugar de «+ Otro color») despliega todos los colores de la tinta, cada uno con su
 * casilla, sus unidades y su precio, para llevar varios. Al plegarlo con dos o más elegidos queda un resumen
 * («Negro ×1 · Rojo ×2») que vuelve a abrir la lista.
 *   Ficha:   nada marcado. Al pulsar «Añadir al carrito» se añaden primero las tintas marcadas
 *            y después el sello, por el camino normal del tema (que lleva el archivo del diseño
 *            y abre la ventana del carrito).
 *   Carrito: el botón de debajo añade las tintas marcadas y recarga la página.
 * Speedball solo se recomienda para Original L y XL y la Fragile L. La Trodat se elige por la medida del SKU
 * del sello, con la misma regla que tintaAlmohadilla_ en Operaciones (20_tintas). Los ex-libris
 * con tinta-opcion también llevan el bloque: el tema les oculta la opción «Tinta». Cada tinta
 * añadida lleva la nota oculta _origen (ficha o carrito) para poder medir de dónde vienen.
 */
(function () {
  'use strict';

  // El sello más grande que admite cada Trodat, de menor a mayor: [nombre, lado mayor, lado menor] en cm.
  // La S y M (tinta-sello) es la de los sellos S y M: hasta 6×5 y Ø5. En las L y XL la almohadilla tiene
  // que ser 1 cm más ancha y 1 cm más alta que el sello: 11×7 → 10×6, 16×9 → 15×8, 21×14 → 20×13.
  var ALMOHADILLAS = [['S y M', 6, 5], ['11x7', 10, 6], ['16x9', 15, 8], ['21x14', 20, 13]];
  var ORDEN = ['', 'S y M', '11x7', '16x9', '21x14', 'ninguna'];
  // Speedball: los SKU que empiezan así. Original L y XL (y su copia en borrador) y la Original Fragile L,
  // en castellano y en inglés (18/10/2026).
  var SPEEDBALL = ['CAU-ORIL-', 'CAU-ORLC-', 'CAU-ORIF-FRA-L', 'CAU-ORIF-FRAG-L'];

  /** Medida del sello sacada de su SKU, en cm: [lado mayor, lado menor], o null. CAU-ORIL-1208 → [12, 8]. */
  function medida(sku) {
    var seg = String(sku || '').trim().toUpperCase().split('-')[2] || '';
    var m = seg.match(/^(\d{2})(\d{2})$/);
    if (m) { var a = Number(m[1]), b = Number(m[2]); return [Math.max(a, b), Math.min(a, b)]; }
    m = seg.match(/^R(\d{3})$/);
    if (m) { var d = Number(m[1]) / 10; return [d, d]; }
    m = seg.match(/^(\d{2})$/);
    if (m) { var e = Number(m[1]); return [e, e]; }
    return null;
  }

  /**
   * Trodat de un sello: la S y M para los sellos S y M y, si es más grande, la L y XL más pequeña
   * que le saca 1 cm de ancho y de alto.
   * «S y M», «11x7», «16x9», «21x14», «ninguna», o '' si no se sabe. Los ex-libris sin medida son S y M.
   */
  function almohadilla(sku) {
    var m = medida(sku);
    if (!m) return /^EXL-/i.test(String(sku || '').trim()) ? 'S y M' : '';
    for (var i = 0; i < ALMOHADILLAS.length; i++) {
      if (m[0] <= ALMOHADILLAS[i][1] && m[1] <= ALMOHADILLAS[i][2]) return ALMOHADILLAS[i][0];
    }
    return 'ninguna';
  }

  /** Con varios sellos, la Trodat del más grande. */
  function almohadillaMayor(skus) {
    var mayor = '';
    skus.forEach(function (s) {
      var a = almohadilla(s);
      if (ORDEN.indexOf(a) > ORDEN.indexOf(mayor)) mayor = a;
    });
    return mayor;
  }

  /** ¿Hay algún Original L y XL o Fragile L entre estos sellos? Solo entonces se recomienda Speedball. */
  function llevaSpeedball(skus) {
    return (skus || []).some(function (s) {
      var sku = String(s || '').trim().toUpperCase();
      return SPEEDBALL.some(function (p) { return sku.indexOf(p) === 0; });
    });
  }

  /** «1-Negro / 16x9cm» → «Negro»: el color, sin el número delante ni el tamaño. */
  function etiquetaColor(opciones) {
    return (opciones || [])
      .filter(function (o) { return o && !/^\s*\d+\s*x\s*\d+/i.test(o); })
      .map(function (o) { return String(o).replace(/^\s*\d+\s*-\s*/, ''); })
      .join(' / ');
  }

  /** Qué tintas se ofrecen a estos sellos (sus SKU), en orden, con sus variantes disponibles. config: el JSON del bloque. */
  function filas(config, skus) {
    var t = config.tintas || {}, n = config.nombres || {}, out = [];
    var pad = almohadillaMayor(skus || []);
    function disponibles(tinta, filtro) {
      return (tinta.variantes || []).filter(function (v) { return v.disponible && (!filtro || filtro(v)); });
    }
    if (t.versacraft) out.push({ rol: 'versacraft', nombre: n.versacraft, tinta: t.versacraft, variantes: disponibles(t.versacraft) });
    if (t.speedball && llevaSpeedball(skus)) {
      out.push({ rol: 'speedball', nombre: n.speedball, tinta: t.speedball, variantes: disponibles(t.speedball) });
    }
    if (pad === 'S y M' && t.trodatSm) {
      out.push({ rol: 'trodat', nombre: n.trodat, tinta: t.trodatSm, variantes: disponibles(t.trodatSm) });
    } else if (/^\d+x\d+$/.test(pad) && t.trodatLxl) {
      out.push({
        rol: 'trodat', nombre: n.trodat + ' ' + pad.replace('x', '×'), tinta: t.trodatLxl,
        variantes: disponibles(t.trodatLxl, function (v) {
          return (v.opciones || []).some(function (o) { return String(o).replace(/\s/g, '').toLowerCase().indexOf(pad) === 0; });
        })
      });
    }
    return out.filter(function (f) { return f.variantes.length; });
  }

  /** La variante de una tinta con ese id o, si ya no está (la Trodat ha cambiado de tamaño), la del mismo color. */
  function buscarVariante(f, id, etiqueta) {
    var v = f.variantes.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v && etiqueta) v = f.variantes.filter(function (x) { return etiquetaColor(x.opciones) === etiqueta; })[0];
    return v || null;
  }

  /** «Negro ×1 · Rojo ×2»: los colores elegidos de una tinta, para cuando la lista está plegada. Pura. */
  function resumenColores(colores) {
    return (colores || []).map(function (c) { return c.etiqueta + ' ×' + c.cantidad; }).join(' · ');
  }

  /** Junta las filas del mismo color: [{id, cantidad}] sin repetidos. */
  function juntar(lista) {
    var out = [], pos = {};
    lista.forEach(function (x) {
      if (pos[x.id] === undefined) { pos[x.id] = out.length; out.push({ id: x.id, cantidad: x.cantidad }); }
      else out[pos[x.id]].cantidad += x.cantidad;
    });
    return out;
  }

  // ─── A partir de aquí, solo en el navegador ───

  function dinero(centimos, formato) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(centimos, formato);
    return (centimos / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function el(etiqueta, clase, texto) {
    var e = document.createElement(etiqueta);
    if (clase) e.className = clase;
    if (texto) e.textContent = texto;
    return e;
  }

  function unidades(input) {
    var n = parseInt(input && input.value, 10);
    return n >= 1 ? Math.min(n, 99) : 1;
  }

  /** Añade tintas al carrito ([{id, cantidad}]), cada una con su nota de origen. Devuelve una promesa. */
  function anadir(items, origen) {
    // Como mucho 10 s: si no, el sello se quedaría esperando a las tintas.
    var control = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var reloj = control ? setTimeout(function () { control.abort(); }, 10000) : null;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (x) { return { id: x.id, quantity: x.cantidad, properties: { _origen: origen } }; }) }),
      signal: control ? control.signal : undefined
    }).then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); })
      .then(function (r) { clearTimeout(reloj); return r; }, function (e) { clearTimeout(reloj); throw e; });
  }

  function campoUnidades(valor, etiqueta) {
    var c = el('input', 'tinta-sugerida__cantidad');
    c.type = 'number';
    c.min = '1';
    c.max = '99';
    c.step = '1';
    c.inputMode = 'numeric';
    c.value = String(valor || 1);
    c.setAttribute('aria-label', etiqueta);
    // Intro en las unidades no envía el formulario (en el carrito sería ir a pagar).
    c.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') { evt.preventDefault(); c.blur(); }
    });
    return c;
  }

  /**
   * Una tinta: foto, casilla, nombre y uso, «Ver tinta» y «Ver colores»; debajo, según el estado:
   *   - plegada, con un color o ninguno: el color, las unidades y el precio (cambiarlos marca la casilla);
   *   - plegada, con dos o más: el resumen «Negro ×1 · Rojo ×2» y el precio total (al pulsarlo se despliega);
   *   - desplegada: todos los colores, cada uno con su casilla, unidades y precio.
   * Columnas fijas para que al marcar no se mueva nada.
   * previa: lo elegido antes de repintar (ver estado()). Devuelve { rol, estado(), reiniciar() }.
   */
  function pintarTinta(ul, f, config, previa, alCambiar) {
    var t = config.textos;
    var st = { abierta: !!(previa && previa.abierta), actual: null, cantidades: {}, elegidos: [] };
    function idDe(c) { var v = c ? buscarVariante(f, c.id, c.etiqueta) : null; return v ? String(v.id) : null; }
    ((previa && previa.colores) || []).forEach(function (c) {
      var id = idDe(c);
      if (!id) return;
      st.cantidades[id] = c.cantidad;
      if (previa.marcada && st.elegidos.indexOf(id) < 0) st.elegidos.push(id);
    });
    st.actual = idDe(previa && previa.actual) || st.elegidos[0] || String(f.variantes[0].id);

    function orden(id) { for (var i = 0; i < f.variantes.length; i++) if (String(f.variantes[i].id) === id) return i; return 999; }
    function cantidad(id) { return st.cantidades[id] || 1; }
    function variante(id) { return buscarVariante(f, id) || f.variantes[0]; }
    function nombreColor(id) { return etiquetaColor(variante(id).opciones) || f.nombre; }
    function elegir(id, si) {
      var i = st.elegidos.indexOf(id);
      if (si && i < 0) { st.elegidos.push(id); st.elegidos.sort(function (a, b) { return orden(a) - orden(b); }); }
      if (!si && i >= 0) st.elegidos.splice(i, 1);
    }

    var li = el('li', 'tinta-sugerida__fila');
    li.setAttribute('data-rol', f.rol);
    var foto = el('span', 'tinta-sugerida__foto');
    if (f.tinta.foto) {
      var img = el('img');
      img.src = f.tinta.foto;
      img.alt = f.tinta.titulo || f.nombre;
      img.loading = 'lazy';
      foto.appendChild(img);
    }
    li.appendChild(foto);

    var cabecera = el('div', 'tinta-sugerida__elegir');
    var marca = el('label', 'tinta-sugerida__marca');
    var casilla = el('input', 'tinta-sugerida__casilla');
    casilla.type = 'checkbox';
    marca.appendChild(casilla);
    var textos = el('span', 'tinta-sugerida__textos');
    textos.appendChild(el('span', 'tinta-sugerida__nombre', f.nombre));
    if (f.tinta.uso) textos.appendChild(el('span', 'tinta-sugerida__uso', f.tinta.uso));
    marca.appendChild(textos);
    cabecera.appendChild(marca);

    var enlaces = el('span', 'tinta-sugerida__enlaces');
    var ver = el('a', 'tinta-sugerida__ver', t.ver);
    ver.href = f.tinta.url;
    ver.target = '_blank';
    ver.rel = 'noopener';
    enlaces.appendChild(ver);
    var colores = el('button', 'tinta-sugerida__enlace tinta-sugerida__colores-boton');
    colores.type = 'button';
    colores.hidden = f.variantes.length < 2;
    colores.addEventListener('click', function () { st.abierta = !st.abierta; pintarAbajo(); });
    enlaces.appendChild(colores);
    cabecera.appendChild(enlaces);
    li.appendChild(cabecera);
    ul.appendChild(li);

    var abajo = [];        // lo que hay debajo de la cabecera (se rehace al plegar o desplegar)
    var precios = [];      // [{nodo, ids}] para recalcular sin rehacer
    var filasLista = [];   // en la lista: [{fila, casilla, cantidad, id}]

    function refrescar() {
      casilla.checked = st.elegidos.length > 0;
      li.classList.toggle('tinta-sugerida__fila--marcada', casilla.checked);
      precios.forEach(function (p) {
        var total = p.ids().reduce(function (s, id) { return s + variante(id).precio * cantidad(id); }, 0);
        p.nodo.textContent = dinero(total, config.moneyFormat);
      });
      filasLista.forEach(function (x) {
        x.casilla.checked = st.elegidos.indexOf(x.id) >= 0;
        x.fila.classList.toggle('tinta-sugerida__color-fila--elegido', x.casilla.checked);
      });
      if (alCambiar) alCambiar();
    }

    function pintarAbajo() {
      abajo.forEach(function (n) { n.remove(); });
      abajo = []; precios = []; filasLista = [];
      colores.textContent = st.abierta ? t.ocultarColores : t.verColores;
      colores.setAttribute('aria-expanded', st.abierta ? 'true' : 'false');

      if (st.abierta) {
        var lista = el('ul', 'tinta-sugerida__colores');
        f.variantes.forEach(function (v) {
          var id = String(v.id), nombre = etiquetaColor(v.opciones) || f.nombre;
          var fila = el('li', 'tinta-sugerida__color-fila');
          var etiqueta = el('label', 'tinta-sugerida__color-nombre');
          var c = el('input', 'tinta-sugerida__color-casilla');
          c.type = 'checkbox';
          etiqueta.appendChild(c);
          etiqueta.appendChild(el('span', '', nombre));
          fila.appendChild(etiqueta);
          var u = campoUnidades(cantidad(id), t.unidades + ' · ' + f.nombre + ' ' + nombre);
          fila.appendChild(u);
          var precio = el('span', 'tinta-sugerida__precio');
          fila.appendChild(precio);
          lista.appendChild(fila);
          precios.push({ nodo: precio, ids: function () { return [id]; } });
          filasLista.push({ fila: fila, casilla: c, cantidad: u, id: id });
          c.addEventListener('change', function () { elegir(id, c.checked); if (c.checked) st.actual = id; refrescar(); });
          u.addEventListener('input', function () { st.cantidades[id] = unidades(u); elegir(id, true); refrescar(); });
          u.addEventListener('change', function () { u.value = String(unidades(u)); });
        });
        li.appendChild(lista);
        abajo.push(lista);
      } else if (st.elegidos.length > 1) {
        var resumen = el('button', 'tinta-sugerida__enlace tinta-sugerida__resumen',
          resumenColores(st.elegidos.map(function (id) { return { etiqueta: nombreColor(id), cantidad: cantidad(id) }; })));
        resumen.type = 'button';
        resumen.setAttribute('aria-label', t.verColores + ' · ' + f.nombre);
        resumen.addEventListener('click', function () { st.abierta = true; pintarAbajo(); });
        var total = el('span', 'tinta-sugerida__precio');
        li.appendChild(resumen);
        li.appendChild(total);
        abajo.push(resumen, total);
        precios.push({ nodo: total, ids: function () { return st.elegidos; } });
      } else {
        var actual = st.elegidos[0] || st.actual;
        var color = el('select', 'tinta-sugerida__color');
        color.setAttribute('aria-label', t.color + ' · ' + f.nombre);
        f.variantes.forEach(function (v) {
          var o = el('option', '', etiquetaColor(v.opciones) || f.nombre);
          o.value = v.id;
          color.appendChild(o);
        });
        color.value = actual;
        var u1 = campoUnidades(cantidad(actual), t.unidades + ' · ' + f.nombre);
        var precio1 = el('span', 'tinta-sugerida__precio');
        li.appendChild(color);
        li.appendChild(u1);
        li.appendChild(precio1);
        abajo.push(color, u1, precio1);
        precios.push({ nodo: precio1, ids: function () { return [color.value]; } });
        // Cambiar el color o las unidades marca la casilla.
        color.addEventListener('change', function () {
          st.cantidades[color.value] = unidades(u1);
          st.actual = color.value;
          st.elegidos = [color.value];
          refrescar();
        });
        u1.addEventListener('input', function () { st.cantidades[color.value] = unidades(u1); st.elegidos = [color.value]; refrescar(); });
        u1.addEventListener('change', function () { u1.value = String(unidades(u1)); });
      }
      refrescar();
    }

    casilla.addEventListener('change', function () {
      if (casilla.checked) st.elegidos = st.elegidos.length ? st.elegidos : [st.actual];
      else st.elegidos = [];
      if (st.abierta) refrescar(); else pintarAbajo();
    });

    pintarAbajo();

    return {
      rol: f.rol,
      /** {marcada, colores: [{id, etiqueta, cantidad}], abierta, actual: {id, etiqueta}} */
      estado: function () {
        return {
          marcada: st.elegidos.length > 0,
          colores: st.elegidos.map(function (id) { return { id: id, etiqueta: nombreColor(id), cantidad: cantidad(id) }; }),
          abierta: st.abierta,
          actual: { id: st.actual, etiqueta: nombreColor(st.actual) }
        };
      },
      reiniciar: function () { st.elegidos = []; st.cantidades = {}; st.abierta = false; pintarAbajo(); }
    };
  }

  /** Lo elegido en el bloque, por tinta: {rol: estado de pintarTinta}. */
  function estado(bloque) {
    var e = {};
    (bloque._tintas || []).forEach(function (x) { e[x.rol] = x.estado(); });
    return e;
  }

  /** Las tintas marcadas, listas para el carrito: [{id, cantidad}]. */
  function elegidas(bloque) {
    var e = estado(bloque), lista = [];
    Object.keys(e).forEach(function (rol) {
      if (!e[rol].marcada) return;
      e[rol].colores.forEach(function (c) { lista.push({ id: Number(c.id), cantidad: c.cantidad }); });
    });
    return juntar(lista);
  }

  function pintar(bloque, config, skus, sellos) {
    var previo = estado(bloque);
    bloque._tintas = [];
    var lista = filas(config, skus);
    Array.prototype.forEach.call(bloque.querySelectorAll(':scope > :not(script)'), function (n) { n.remove(); });
    bloque.hidden = !lista.length;
    if (!lista.length) return;
    if (config.contexto === 'ficha') {
      bloque.appendChild(el('p', 'tinta-sugerida__titulo', config.textos.tituloFicha));
    } else {
      bloque.appendChild(el('p', 'tinta-sugerida__titulo', config.textos.tituloCarrito));
      bloque.appendChild(el('p', 'tinta-sugerida__texto', sellos.length === 1
        ? config.textos.paraUno.split('[sello]').join(sellos[0].titulo)
        : config.textos.paraVarios));
    }
    var ul = el('ul', 'tinta-sugerida__lista');
    bloque.appendChild(ul);
    var error = el('p', 'tinta-sugerida__error', config.textos.error);
    error.hidden = true;
    error.setAttribute('role', 'alert');
    var boton = null;
    function alCambiar() {
      var hay = elegidas(bloque).length > 0;
      if (boton) boton.disabled = !hay;
      // El pago rápido (Shop Pay, PayPal…) no lleva las tintas: se esconde mientras haya alguna marcada.
      var form = config.contexto === 'ficha' && bloque.closest('form');
      var pago = form && form.querySelector('.shopify-payment-button');
      if (pago) pago.style.display = hay ? 'none' : '';
    }
    bloque._tintas = [];
    lista.forEach(function (f) { bloque._tintas.push(pintarTinta(ul, f, config, previo[f.rol], alCambiar)); });

    if (config.contexto !== 'ficha') {
      boton = el('button', 'btn btn--small tinta-sugerida__anadir', config.textos.anadir);
      boton.type = 'button';
      boton.addEventListener('click', function () {
        var items = elegidas(bloque);
        if (!items.length) return;
        boton.disabled = true;
        bloque.classList.add('tinta-sugerida--cargando');
        anadir(items, 'carrito').then(function () { window.location.reload(); }, function () {
          bloque.classList.remove('tinta-sugerida--cargando');
          boton.disabled = false;
          error.hidden = false;
        });
      });
      bloque.appendChild(boton);
    }
    bloque.appendChild(error);
    alCambiar();
  }

  function iniciarFicha(bloque, config) {
    var form = bloque.closest('form');
    if (!form) return;
    var selectorId = form.querySelector('[name="id"]');
    function skusActuales() {
      var id = selectorId ? selectorId.value : config.varianteActual;
      return [config.variantes[String(id)] || ''];
    }
    pintar(bloque, config, skusActuales(), []);

    // El tema cambia el selector «id» al elegir medida; se lee justo después.
    form.addEventListener('change', function (evt) {
      if (bloque.contains(evt.target)) return;
      setTimeout(function () { pintar(bloque, config, skusActuales(), []); }, 0);
    });

    // Antes de que el tema añada el sello, se añaden las tintas marcadas. Después se vuelve a enviar
    // el formulario con requestSubmit, que lanza un «submit» de verdad: lo reciben el tema y las apps
    // (Cloudlift, analítica) como si no hubiéramos pasado por aquí.
    var enviando = false, reenviando = false;
    function reenviar(boton) {
      reenviando = true;
      try {
        if (form.requestSubmit) form.requestSubmit(boton && boton.form === form ? boton : null);
        else if (window.jQuery) window.jQuery(form).trigger('submit');
        else form.submit();
      } finally {
        reenviando = false;
      }
    }
    document.addEventListener('submit', function (evt) {
      if (evt.target !== form || reenviando) return;
      if (enviando) {   // otro clic mientras se añaden las tintas: el sello ya va detrás
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }
      if (evt.defaultPrevented) return;
      var items = elegidas(bloque);
      if (!items.length) return;
      // Si el tema no va a añadir el sello (agotado, ya cargando o cantidad 0), tampoco las tintas.
      var botonSello = form.querySelector('[data-add-to-cart]');
      var cantidad = form.querySelector('[name="quantity"]');
      if (botonSello && botonSello.hasAttribute('aria-disabled')) return;
      if (cantidad && !(parseInt(cantidad.value, 10) >= 1)) return;
      var boton = evt.submitter;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      enviando = true;
      bloque.classList.add('tinta-sugerida--cargando');
      bloque.setAttribute('aria-busy', 'true');
      var error = bloque.querySelector('.tinta-sugerida__error');
      function fin() {
        bloque.classList.remove('tinta-sugerida--cargando');
        bloque.removeAttribute('aria-busy');
        enviando = false;
        reenviar(boton);
      }
      anadir(items, 'ficha').then(function () {
        (bloque._tintas || []).forEach(function (x) { x.reiniciar(); });
        if (error) error.hidden = true;
      }, function () {
        if (error) error.hidden = false;   // el sello se añade igual
      }).then(fin, fin);
    }, true);
  }

  function iniciarCarrito(bloque, config) {
    var sellos = config.sellos || [];
    function skus() { return sellos.map(function (s) { return s.sku; }); }
    pintar(bloque, config, skus(), sellos);

    // Si se quita un sello o se cambia una cantidad sin recargar, se rehace el aviso.
    if (!window.jQuery) return;
    window.jQuery(document).ajaxSuccess(function (e, xhr, opciones) {
      if (!/\/cart\/(change|update)\.js/.test((opciones && opciones.url) || '')) return;
      var cart = xhr.responseJSON;
      if (!cart || !cart.items) return;
      var claves = cart.items.map(function (i) { return i.key; });
      sellos = sellos.filter(function (s) { return claves.indexOf(s.key) >= 0; });
      var hayTinta = cart.items.some(function (i) { return /^TIN-/i.test(i.sku || ''); });
      if (!sellos.length || hayTinta) { bloque.hidden = true; return; }
      pintar(bloque, config, skus(), sellos);
    });
  }

  if (typeof document !== 'undefined') {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tinta-sugerida]'), function (bloque) {
      var nodo = bloque.querySelector('[data-tinta-config]');
      if (!nodo) return;
      var config;
      try { config = JSON.parse(nodo.textContent); } catch (e) { console.warn('tinta-sugerida: configuración no válida', e); return; }
      if (config.contexto === 'ficha') iniciarFicha(bloque, config);
      else iniciarCarrito(bloque, config);
    });
  }

  if (typeof module !== 'undefined') {
    module.exports = {
      medida: medida, almohadilla: almohadilla, almohadillaMayor: almohadillaMayor, llevaSpeedball: llevaSpeedball,
      etiquetaColor: etiquetaColor, filas: filas, buscarVariante: buscarVariante, juntar: juntar, resumenColores: resumenColores
    };
  }
})();
